headerAlertBarShouldRender